import {post } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getPageOperationListForValueByParams = record => post(url.GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS, record)

